import {
	getCoreRowModel,
	getSortedRowModel,
	useReactTable,
} from "@tanstack/react-table";
import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";
import { OPEN_ORDERS_GRID_CLASS } from "./constants/positions.constants.ts";
import { getOpenOrdersColumns } from "./open-orders-columns.tsx";
import type {
	ModifyOrderValues,
	OpenOrderRowItem,
	OpenOrdersTableMeta,
} from "./types/positions.types.ts";
import { VirtualizedGridTable } from "./virtualized-grid-table.tsx";

const coreRowModel = getCoreRowModel();
const sortedRowModel = getSortedRowModel();

type OpenOrdersTableProps = {
	openOrders: OpenOrderRowItem[];
	onCancelOrder: (order: OpenOrderRowItem) => void;
	onCancelAll: () => void;
	onModifyOrder: (order: OpenOrderRowItem, values: ModifyOrderValues) => void;
	isError?: boolean;
	onRetry?: () => void;
};

export function OpenOrdersTable({
	openOrders,
	onCancelOrder,
	onCancelAll,
	onModifyOrder,
	isError,
	onRetry,
}: OpenOrdersTableProps) {
	const { t } = useTranslate();
	const columns = useMemo(() => getOpenOrdersColumns(), []);

	const meta: OpenOrdersTableMeta = {
		onCancel: onCancelOrder,
		onCancelAll,
		onModify: onModifyOrder,
	};

	const table = useReactTable({
		data: openOrders,
		columns,
		meta,
		getCoreRowModel: coreRowModel,
		getSortedRowModel: sortedRowModel,
	});

	return (
		<VirtualizedGridTable
			table={table}
			gridClass={OPEN_ORDERS_GRID_CLASS}
			estimateSize={52}
			emptyMessage={t("portfolio.no-orders")}
			isError={isError}
			onRetry={onRetry}
		/>
	);
}
